import { Text } from "@utils/helper";
import { buildClass } from "@utils/tag";
import useTranslation from "next-translate/useTranslation";
import { addStatusQuery } from "@utils/addStatusQuery";
import { useRouter } from "next/router";

export const LoginAction = ({ isIndividual }) => {
  const { t } = useTranslation("login");
  const router = useRouter();

  return (
    <div className="flex w-full bg-white">
      <div
        tabIndex={0}
        onClick={() => addStatusQuery(router, { action: 1 })}
        onKeyDown={(e) => {
          if (e.key === "Enter") addStatusQuery(router, { action: 1 });
        }}
        className={buildClass(
          "flex border-transparent transition-all",
          "justify-center items-center px-4 py-[18px]",
          "w-1/2 h-[57px]  border-b-4 border-solid cursor-pointer",
          { "!border-[#0366FF]": isIndividual }
        )}
      >
        <Text
          color={isIndividual ? "#0366FF" : "#8F8F8F"}
          fontType={isIndividual ? "Expo_sim" : "Expo_bok"}
          weight={isIndividual ? 500 : 400}
          className="capitalize"
        >
          {t("individual")}
        </Text>
      </div>
      <span className="!w-px min-h-full  bg-[#8F8F8F29]" />
      <div
        tabIndex={0}
        onClick={() => addStatusQuery(router, { action: 2 })}
        onKeyDown={(e) => {
          if (e.key === "Enter") addStatusQuery(router, { action: 2 });
        }}
        className={buildClass(
          "flex border-transparent transition-all",
          "justify-center items-center w-1/2 h-14",
          "border-b-4 border-solid cursor-pointer",
          { "!border-[#0366FF]": !isIndividual }
        )}
      >
        <Text
          color={!isIndividual ? "#0366FF" : "#8F8F8F"}
          fontType={!isIndividual ? "Expo_sim" : "Expo_bok"}
          weight={!isIndividual ? 500 : 400}
          className="capitalize"
        >
          {t("organization")}
        </Text>
      </div>
    </div>
  );
};
